export const ANIMATION_DURATION = 0.2;
